import React, { Component } from 'react';
import { Container, List, Button, Dimmer, Loader, TextArea, Icon, Modal, Header, Image, Grid, Statistic, Checkbox, Input, Message, Form, Select } from "semantic-ui-react"
import moment from 'moment'
import CreditCardInput from 'react-credit-card-input';
// import Cards from 'react-credit-cards';
import {notify} from 'react-notify-toast';
import { translate } from 'react-i18next';
import API from '../utils/API'
import logo from '../images/logo_only.png'
import _ from 'lodash'
import {euroCountries} from '../constants'

const STRIPE_BASIC_ID = 'premium-basic'
const STRIPE_SIXMONTHS_ID = 'premium-6-months-v2'
const STRIPE_YEARLY_ID = 'premium-yearly'
const NUMBER_REGEXP = /^(?:4[0-9]{12}(?:[0-9]{3})?|5[1-5][0-9]{14}|3[47][0-9]{13}|6(?:011|5[0-9]{2})[0-9]{12}|(?:2131|1800|35\d{3})\d{11})$/gm
const DATE_REGEXP = /^(0[1-9]|1[0-2])\/?([0-9]{2})$/

class PremiumPane extends Component {

  constructor(props) {
    super(props)
    var userLang = navigator.language || navigator.userLanguage;
    var isDollars = !_.includes(euroCountries, userLang)
    this.state = {
      fetching: null,
      infoFetched: false,
      start: null,
      trialEnd: null,
      status: null,
      planName: null,
      planPrice: null,
      expirationDate: null,
      promocode: null,
      currentPeriodEnd: null,
      cancelModalOpen: false,
      cancelFetching: false,
      canceled: false,
      monthsToPause: 1,
      holdersName: '',
      cardNumber: '',
      expiry: '',
      cvc: '',
      updateFetching: false,
      updateModalOpen: false,
      changePlanModalOpen: false,
      changePlanLoading: false,
      notPremium: false,
      paymentModalOpen: false,
      paymentFetching: false,
      planId: null,
      havePromocode: false,
      promocodeFetching: false,
      isPromocodeValid: null,
      trialPeriod: (props.user && props.user.stripeId) ? 0 : 14,
      promocodeValue: null,
      currency: null,
      stripePaused: null,
      selectedNewPlan: null,
      isDollars: isDollars,
      otherPlans: [],
      pricing: {
        monthly: isDollars ? '$9.99' : '7,99€',
        semestrial: isDollars ? '$49.99' : '39,99€',
        yearly: isDollars ? '$89.99' : '71,99€'
      },
      plans: {
        monthly: `${STRIPE_BASIC_ID}${isDollars ? '-dollars': ''}`,
        semestrial: `${STRIPE_SIXMONTHS_ID}${isDollars ? '-dollars': ''}`,
        yearly: `${STRIPE_YEARLY_ID}${isDollars ? '-dollars': ''}`,
      },
      cancelReason: null,
      reasonAddon: "",
      signedUp: false,
      hostedInvoiceURL: '',
      pauseSubModal: false,
      loading: false
    }
    this.redirectToPayment = this.redirectToPayment.bind(this)
    this.promocode = null
  }

  componentDidMount () {
    if (this.props.user && !this.state.infoFetched) {
      moment.locale(this.props.i18n.language)
      this.isUserPremium()
    }
  }

  getBillingDate() {
    return this.getFormattedDate(
      moment()
        .add(this.state.trialPeriod, 'days')
        .toJSON()
    );
  }

  redirectToPayment(url) {
    window.location.href = url || this.state.hostedInvoiceURL;
  }

  async isUserPremium () {
    const { user } = this.props
    this.setState({fetching: true})
    // console.log(this.props.user)
    const response = await API.isUserPremium(user.id)
    if (response.ok) {
      if (response.data.isPremium) {
        this.setState({notPremium:false})
        this.getPremiumInfo()
      } else {
        this.setState({notPremium: true, fetching: user.stripeSubscription, infoFetched: true})
        if (user.stripeSubscription) {
          this.getPremiumInfo()
        }
      }
      
    } else {
      notify.show(this.props.t('messages:premiumInfoKO'), 'error')
      this.setState({fetching: false})
    }
  }

  async getPremiumInfo () {
    const response = await API.getPremiumInfo()
    if (response.ok) {
      if (response.data) {
        const {start, trialEnd, status, planPrice, expirationDate, billingCycleAnchor, promocode, currentPeriodEnd, currentPeriodStart, canceled, currency, hostedInvoiceURL, stripePaused} = response.data
        let isDollars = currency === 'usd'
        let otherPlans = []
        if (isDollars !== this.state.isDollars) {
          this.setState({
            pricing: {
              monthly: isDollars ? '$9.99' : '7,99€',
              semestrial: isDollars ? '$49.99' : '39,99€',
              yearly: isDollars ? '$89.99' : '71,99€'
            },
            plans: {
              monthly: `${STRIPE_BASIC_ID}${isDollars ? '-dollars': ''}`,
              semestrial: `${STRIPE_SIXMONTHS_ID}${isDollars ? '-dollars': ''}`,
              yearly: `${STRIPE_YEARLY_ID}${isDollars ? '-dollars': ''}`,
            }
          })
        }
        let planName = response.data.planName;
        if (planName && planName.toLowerCase().indexOf('yearly') !== -1) {
          planName = this.props.t('premium:yearly')
        }
        else if (planName && planName.indexOf('6') !== -1) {
          planName = this.props.t('premium:halfYearly')
          otherPlans.push({
            name: this.props.t('premium:yearly'),
            pricing: `${isDollars ? '$89.99' : '71,99€'}`,
            stripeId: `${STRIPE_YEARLY_ID}${isDollars ? '-dollars' : ''}`,
            per: this.props.t('premium:perYear')
          })
        } else {
          planName = this.props.t('premium:monthly')
          otherPlans.push({
            name: this.props.t('premium:yearly'),
            pricing: `${isDollars ? '$89.99' : '71,99€'}`,
            stripeId: `${STRIPE_YEARLY_ID}${isDollars ? '-dollars' : ''}`,
            per: this.props.t('premium:perYear')
          },{
            name: this.props.t('premium:halfYearly'),
            pricing: `${isDollars ? '$49.99' : '39,99€'}`,
            stripeId: `${STRIPE_SIXMONTHS_ID}${isDollars ? '-dollars' : ''}`,
            per: this.props.t('premium:per6Months')
          })
        }
        
        this.setState({fetching: false, infoFetched: true, start, billingCycleAnchor, trialEnd, status, planName, planPrice, expirationDate, promocode, currentPeriodEnd, currentPeriodStart, canceled, currency, otherPlans, hostedInvoiceURL, stripePaused})
      }
    } else {
      notify.show(this.props.t('messages:premiumInfoKO'), 'error')
      this.setState({fetching: false})
    }
  }

  setValue (obj) {
    this.setState({ [obj.key]: obj.value })
  }

  getFormattedDate (inputDate, short) {
    const date = typeof inputDate === 'string' ? inputDate : inputDate * 1000
    return this.props.i18n.language === 'en' ? moment(date).format(short ? 'MMM Do' : 'MMMM Do YYYY') : moment(date).format(short ? 'D MMM' : 'D MMMM YYYY')
  }

  getStatuscolor (status) {
    if (this.state.canceled) {
      return '#ff7a7a'
    }
    switch (status) {
      case 'active':
      case undefined:
      case null:
        return '#a8ff7a'
      case 'trialing':
        return '#ddf3ff'
      default:
        return '#ff7a7a'
    }
  }

  async cancelPremium () {
    this.setState({cancelFetching: true})
    const {cancelReason, reasonAddon} = this.state
    const response = await API.cancelPremium(cancelReason, reasonAddon)
    if (response.ok) {
      notify.show(this.props.t('messages:cancelOK'), 'success')
      this.setState({cancelModalOpen: false, cancelFetching: false, canceled: true})
      this.isUserPremium()
    } else {
      notify.show(this.props.t('messages:cancelKO'), 'error')
      this.setState({cancelFetching: false, cancelModalOpen: false})
    }
  }

  async updateCreditCard () {
    this.setState({updateFetching: true})
    try {
      const token = await API.createStripeToken(this.state.cardNumber, this.state.expiry, this.state.cvc)
      if (token.error) {
        notify.show(token.error.message, 'error')
        this.setState({updateModalOpen:false, updateFetching: false})
      } else {
        const response = await API.updateCreditCard(token.id)
        if (response.ok) {
          notify.show(this.props.t('messages:cardUpdateOK'), 'success')
          this.setState({updateModalOpen: false, updateFetching: false})
        } else {
          notify.show(this.props.t('messages:cardUpdateKO'), 'error')
          this.setState({updateFetching: false, updateModalOpen: false})
        }
      }
    } catch(e) {
      notify.show(this.props.t('messages:cardInvalid'), 'error')
      this.setState({updateModalOpen:false, updateFetching: false})
    }
  }

  isFormValid () {
    return this.state.cardNumber.replace(/\s/g,'').match(NUMBER_REGEXP) &&
      this.state.expiry.replace(/\s/g,'').match(DATE_REGEXP)
  }

  async subscribeToPremium () {
    // if (!this.isFormValid()) {
    //   notify.show(this.props.t('messages:wrongCardData'), 'error')
    //   return
    // }
    this.setState({paymentFetching: true})
    try {
      const token = await API.createStripeToken(this.state.cardNumber, this.state.expiry, this.state.cvc)
      if (token.error) {
        notify.show(token.error.message, 'error')
        this.setState({paymentModalOpen:false, paymentFetching: false})
      } else {
        const response = await API.subscribeStripe(this.props.user.email, token.id, this.state.planId, this.promocode)
        if (response.ok) {
          if (response.data.hostedInvoiceURL) {
            this.redirectToPayment(response.data.hostedInvoiceURL)
            return
          }
          notify.show(this.props.t('messages:subscribeOK'), 'success')
          this.setState({paymentModalOpen: false, paymentFetching: false, signedUp: true})
          this.isUserPremium()
        } else {
          if (response.data.message) {
            notify.show(`${this.props.t('messages:error')}: ${response.data.message}`, 'error', 10000)
          } else {
            notify.show(this.props.t('messages:subscribeKO'), 'error')
          }
          this.setState({paymentFetching: false, paymentModalOpen: false})
        }
      }
    } catch (error) {
      notify.show(this.props.t('messages:cardInvalid'), 'error')
      this.setState({paymentModalOpen:false, paymentFetching: false})
    }
  }

  async validatePromocode () {
    this.setState({promocodeFetching: true})
    const response = await API.verifyPromocode(this.state.promocodeValue)
    if (response.ok) {
      this.promocode = this.state.promocodeValue
      this.setState({promocodeFetching: false, isPromocodeValid: response.data.valid, trialPeriod: response.data.period})
    } else {
      this.setState({promocodeFetching: false, isPromocodeValid: false})
    }
  }

  setPromocode (promocodeValue) {
    this.setState({promocodeValue, isPromocodeValid: null})
  }

  toggle = () => this.setState({ havePromocode: !this.state.havePromocode })

  getTutoImage (image) {
    let locale = this.props.i18n.language.substr(0,2)
    if (locale !== 'fr' && locale !== 'en' && locale !== 'es' && locale !== 'it' && locale !== 'pt') {
      locale = 'en'
    }
    return require(`../images/tuto/${locale}/${image}.png`)
  }

  async changePlan() {
    this.setState({changePlanLoading: true})
    try {
      const response = await API.changePlan(this.state.selectedNewPlan)      
      if (response.ok) {
        if (response.data.hostedInvoiceURL) {
          this.redirectToPayment(response.data.hostedInvoiceURL)
        }
        this.setState({changePlanLoading: false, changePlanModalOpen: false, fetching: true})
        this.getPremiumInfo()
        notify.show(this.props.t('messages:updateOK'), "success")
      } else {
        notify.show(this.props.t('messages:error'), "error")
        this.setState({changePlanLoading: false})
      }
    } catch (error) {
      notify.show(error.message, "error")
    }
  }

  async pauseSubscription() {
    this.setState({loading: true})
    try {
      const response = await API.pauseSubscription(this.state.monthsToPause)      
      if (response.ok) {
        this.setState({loading: false, stripePaused: response.data.stripePaused, pauseSubModal: false})
        notify.show(this.props.t('messages:pauseOK'), "success")
      } else {
        notify.show(this.props.t('messages:error'), "error")
        this.setState({loading: false})
      }
    } catch (error) {
      notify.show(error.message, "error")
    }
  }

  async unpauseSubscription() {
    this.setState({loading: true})
    try {
      const response = await API.unpauseSubscription()      
      if (response.ok) {
        this.setState({loading: false, stripePaused: null})
        this.getPremiumInfo()
      } else {
        notify.show(this.props.t('messages:error'), "error")
        this.setState({loading: false})
      }
    } catch (error) {
      notify.show(error.message, "error")
    }
  }


  render() {
    const {user, t} = this.props
    const {currency, hostedInvoiceURL, stripePaused, billingCycleAnchor} = this.state
    const isDollars = currency === 'usd'
    return (
          <div id="premium-pane">
            {user &&
              <Container text>
                <div style={{position: 'relative', borderBottom: '1px solid black'}}>
                  <h2 style={{textTransform: 'uppercase', marginBottom: '1rem'}}>{t('tabs:premium')}</h2>
                </div>
                {this.state.fetching && 
                    <Dimmer active>
                      <Loader />
                    </Dimmer>
                  }
                { !this.state.fetching && this.state.infoFetched && this.state.notPremium &&
                  <div>
                    <Image centered src={logo} style={{maxHeight: '3rem'}} />
                    <div className="text-center" id="premium">PREMIUM</div>
                    <p>{t('premium:premiumUnlocks')}</p>
                    <p id="catchphrase">{t('premium:premiumSlogan')}</p>
                    <div className="text-center">
                      <List inverted className="dib">
                        <List.Item icon='dot circle outline' content={t('premium:point1')} />
                        <List.Item icon='dot circle outline' content={t('premium:point2')} />
                        <List.Item icon='dot circle outline' content={t('premium:point3')} />
                        <List.Item icon='dot circle outline' content={t('premium:point4')} />
                        <List.Item icon='dot circle outline' content={t('premium:point5')} />
                      </List>
                    </div>
                    <p id="no-engagement">{t('premium:freeTrial')}</p>
                    {/* <div style={{border: '2px solid #05bb05', marginTop: '1rem', marginBottom: '1rem', padding: '0.5rem'}}>
                      <p style={{textAlign: 'center', fontFamily: 'Barlow-Bold'}}>{t('promoTuto:line1')}<br/>
                      <span style={{color: '#05de05', fontFamily: 'Barlow-Bold'}}>{t('promoTuto:line2')}</span></p>
                      <ol>
                        <li>{t('promoTuto:step1')}</li>
                        <li>{t('promoTuto:step2')}</li>
                        <li>{t('promoTuto:step3')}</li>
                        <li>{t('promoTuto:step4')}</li>
                        <li>{t('promoTuto:step51')} <span style={{color: '#05de05', fontFamily: 'Barlow-Bold'}}>{t('promoTuto:step52')}</span> {t('promoTuto:step53')}</li>
                      </ol>
                      <p style={{color: 'red', textAlign: 'center'}}>{t('promoTuto:warning')}</p>
                    </div> */}
                    <Grid className="text-center" columns={3} stackable padded>
                      <Grid.Column>
                        <div className="pricing-header">{t('premium:monthly')}</div>
                        <div className="statistics-container">
                          <Statistic as='div' size="tiny">
                            <Statistic.Value>{this.state.pricing.monthly}</Statistic.Value>
                            <Statistic.Label>{t('premium:perMonth')}</Statistic.Label>
                          </Statistic>
                        </div>
                        <div className="text-center">
                          <Button onClick={() => this.setState({paymentModalOpen: true, planId: this.state.plans.monthly})}>{t('premium:subscribe')}</Button>
                        </div>
                      </Grid.Column>
                      <Grid.Column>
                      <div className="pricing-header">{t('premium:halfYearly')}</div>
                        <div className="statistics-container">
                          <Statistic as='div' size="tiny">
                            <Statistic.Value>{this.state.pricing.semestrial}</Statistic.Value>
                            <Statistic.Label>{t('premium:per6Months')}</Statistic.Label>
                          </Statistic>
                        </div>
                        <div className="text-center">
                          <Button onClick={() => this.setState({paymentModalOpen: true, planId: this.state.plans.semestrial})}>{t('premium:subscribe')}</Button>
                        </div>
                      </Grid.Column>
                      <Grid.Column>
                      <div className="pricing-header">{t('premium:yearly')}</div>
                        <div className="statistics-container">
                          <Statistic as='div' size="tiny">
                            <Statistic.Value>{this.state.pricing.yearly}</Statistic.Value>
                            <Statistic.Label>{t('premium:perYear')}</Statistic.Label>
                          </Statistic>
                        </div>
                        <div className="text-center">
                          <Button onClick={() => this.setState({paymentModalOpen: true, planId: this.state.plans.yearly})}>{t('premium:subscribe')}</Button>
                        </div>
                      </Grid.Column>
                    </Grid>
                    <Modal closeIcon trigger={<a id="promocode-modal-link">{t('premium:promocodeModal.link')}</a>}>
                      <Modal.Content>
                        <Modal.Description>
                          <Header>{t('premium:promocodeModal.title')}</Header>
                          <p style={{padding: '1rem 4rem'}}>
                            {t('premium:promocodeModal.intro')}<br/>
                            <b>{t('premium:promocodeModal.intro2')}</b>
                          </p>
                          <ul id="tuto-list">
                            <li>{t('premium:promocodeModal.step1')}
                              <Image src={this.getTutoImage('button')} style={{maxHeight: '3rem'}}/>
                            </li>
                            <li>{t('premium:promocodeModal.step2')}
                              <Image src={this.getTutoImage('toggle')} style={{maxHeight: '6rem'}}/>
                            </li>
                            <li>{t('premium:promocodeModal.step3')}</li>
                            <li>{t('premium:promocodeModal.step4')}
                              <Image src={this.getTutoImage('success')} style={{maxHeight: '4rem'}} />
                            </li>
                            <li>{t('premium:promocodeModal.step5')}</li>
                          </ul>
                        </Modal.Description>
                      </Modal.Content>
                    </Modal>
                  </div>
                }
                { !this.state.fetching && this.state.infoFetched && !this.state.notPremium && stripePaused &&
                    <List inverted divided relaxed>
                      <List.Item>
                        <List.Content>
                          <label>{t('premium:pausedUntil')}</label>
                          <List.Description>
                          {this.getFormattedDate(moment(stripePaused.expirationDate).toJSON())}
                          </List.Description>
                        </List.Content>
                      </List.Item>
                      <List.Item>
                        <List.Content>
                          <label>{t('premium:nextBilling')}</label>
                          <List.Description>
                          {this.getFormattedDate(moment(stripePaused.expirationDate + stripePaused.dateOffset).toJSON())}
                          </List.Description>
                        </List.Content>
                      </List.Item>
                    </List>
                }
                { !this.state.fetching && this.state.infoFetched && !this.state.notPremium && !stripePaused &&
                    <List inverted divided relaxed>
                          { !this.state.promocode && !user.stripeSubscription && user.premiumDetails &&
                            <List.Item>
                              <List.Content>
                                <label>{t('premium:subscriptionFrom')}</label>
                                <List.Description>
                                {user.premiumDetails.transactionReceipt ? <div><Icon size='large' name="apple"/> Apple iTunes Store</div> : <div><Icon size='large' name="android"/>Google Play Store</div>}
                                </List.Description>
                              </List.Content>
                            </List.Item>
                          }
                          <List.Item>
                            <List.Content>
                              {/* <List.Header>Age</List.Header> */}
                              <label>{this.state.planName || 'Premium basic'}</label>
                              {(user.stripeSubscription || this.state.signedUp) &&
                                <List.Description>
                                  {isDollars ? '$' : ''}{this.state.planPrice / 100}{!isDollars ? '€' : ''} {this.state.planPrice > 4999 ? this.props.t('premium:perYear') : this.state.planPrice > 2000 ? this.props.t('premium:per6Months') : this.props.t('premium:perMonth')}
                                </List.Description>
                              }
                              {this.state.promocode &&
                                <List.Description>
                                  {t('premium:promocode')}
                                </List.Description>
                              }
                            </List.Content>
                          </List.Item>
                          { !this.state.promocode &&
                            <List.Item>
                              <List.Content>
                                <label>{t('premium:signupDate')}</label>
                                <List.Description>
                                {this.getFormattedDate(this.state.start)}
                                </List.Description>
                              </List.Content>
                            </List.Item>
                          }
                          { this.state.promocode &&
                            <List.Item>
                              <List.Content>
                                <label>{t('premium:accessUntil')}</label>
                                <List.Description>
                                {this.getFormattedDate(this.state.expirationDate)}
                                </List.Description>
                              </List.Content>
                            </List.Item>
                          }
                          {this.state.trialEnd && !this.state.canceled && <List.Item>
                            <List.Content>
                            <label>{t('premium:nextBilling')}</label>
                              <List.Description>
                              {this.getFormattedDate(this.state.currentPeriodEnd)}
                              </List.Description>
                            </List.Content>
                          </List.Item>
                          }
                          {this.state.currentPeriodStart && this.state.currentPeriodEnd &&
                            <List.Item>
                              <List.Content>
                              <label>{t('premium:currentPeriod')}</label>
                                <List.Description>
                                  {this.getFormattedDate(this.state.currentPeriodStart, true)} - {this.getFormattedDate(this.state.currentPeriodEnd, true)}
                                </List.Description>
                              </List.Content>
                            </List.Item>
                          }
                          { !this.state.promocode &&
                            <List.Item>
                              <List.Content>
                              <label>{t('premium:status')}</label>
                                <List.Description style={{color: this.getStatuscolor(this.state.status)}}>
                                  {this.state.canceled ? t('premium:cancelAtEnd') : t(`premium:statuses.${this.state.status || 'active'}`)}
                                  
                                </List.Description>
                                {hostedInvoiceURL && (this.state.status === 'incomplete' || this.state.status === 'past_due') && <Button style={{marginTop: 10}} className="cta" onClick={() => this.redirectToPayment(hostedInvoiceURL)}>{ this.state.status === 'incomplete' ? t(`premium:authenticatePayment`) : t(`premium:seeInvoice`)}</Button>}
                              </List.Content>
                            </List.Item>
                          }
                        </List>
                }
                {this.props.user.stripeSubscription && !this.state.canceled && !this.state.fetching && !this.state.notPremium && <div className="text-center mt30"> 
                  {this.state.otherPlans.length > 0 && !stripePaused && <Modal closeOnDimmerClick closeIcon open={this.state.changePlanModalOpen} onClose={() => this.setState({changePlanModalOpen: false})} trigger={<div style={{textAlign:'center', marginTop: 20}}><Button  style={{width: '22rem'}} onClick={() => this.setState({changePlanModalOpen: true})}>{t('premium:changePlan')}</Button></div>}>
                      <Modal.Content>
                        <Modal.Description>
                          <Header>{t('premium:changePlanTitle')}</Header>
                          <div className="text-center mt30">
                            <p>{t('premium:changePlanContent')}</p>
                          </div>
                          <Form id="pricing-form">
                            <Grid columns={this.state.otherPlans.length} divided>
                            <Grid.Row>
                              {this.state.otherPlans.map(plan =>
                                <Grid.Column>
                                <Form.Field className="new-plan-field">
                                  <Checkbox
                                    radio
                                    name={plan.stripeId}
                                    value={plan.stripeId}
                                    checked={this.state.selectedNewPlan === plan.stripeId}
                                    onChange={() => this.setState({selectedNewPlan: plan.stripeId})}
                                  />
                                  <p className="new-plan-container" onClick={() => this.setState({selectedNewPlan: plan.stripeId})}>
                                    <span id="new-plan-name">{plan.name}</span><br/>
                                    <span id="new-plan-price">{plan.pricing}</span><br/>
                                    <span>{plan.per}</span>
                                  </p>
                                </Form.Field>
                                </Grid.Column>
                              )}
                            </Grid.Row>
                            </Grid>
                          </Form>
                          <div className="text-center mt30">
                            <Button disabled={!this.state.selectedNewPlan} loading={this.state.changePlanLoading} onClick={() => this.changePlan()}>{t('premium:confirm')}</Button>
                          </div>
                        </Modal.Description>
                      </Modal.Content>
                    </Modal>}
                  
                  {!stripePaused && <Modal closeIcon open={this.state.updateModalOpen} onClose={() => this.setState({updateModalOpen: false})} trigger={<div style={{textAlign:'center', marginTop: 20}}><Button icon style={{width: '22rem'}} onClick={() => this.setState({updateModalOpen: true})}><Icon className="button-icon" name='credit card alternative' /> {t('premium:updateCC')}</Button></div>}>
                    <Modal.Content>
                      <Modal.Description>
                        <Header>{t('premium:updateModal.title')}</Header>
                        <div className="text-center mt30">
                          <p>{t('premium:updateModal.content')}</p>
                          <CreditCardInput
                            cardNumberInputProps={{ value: this.state.cardNumber, onChange: (e) => this.setValue({key: 'cardNumber', value: e.nativeEvent.target.value}) }}
                            cardExpiryInputProps={{ value: this.state.expiry, onChange: (e) => this.setValue({key: 'expiry', value: e.nativeEvent.target.value}) }}
                            cardCVCInputProps={{ value: this.state.cvc, onChange: (e) => this.setValue({key: 'cvc', value: e.nativeEvent.target.value}) }}
                            fieldClassName="input"
                          />
                        </div>
                        <div className="text-center mt30">
                          <Button color='grey' loading={this.state.updateFetching} onClick={() => this.updateCreditCard()}>{t('common:update')}</Button>
                        </div>
                      </Modal.Description>
                    </Modal.Content>
                  </Modal>}
                  {stripePaused && <Modal closeIcon open={this.state.unpauseModal} onClose={() => this.setState({unpauseModal: false})} trigger={<div id="unpauseModalTrigger" style={{textAlign:'center', marginTop: 20}}><Button icon style={{width: '22rem'}} onClick={() => this.setState({unpauseModal: true})}>{t('premium:unpauseSub')}</Button></div>}>
                    <Modal.Content>
                      <Modal.Description>
                        <Header>{t('premium:unpauseSub')}</Header>
                        <div className="text-center mt30">
                          <p>{t('premium:unpauseText')}</p>
                        </div>
                        <div className="text-center mt30">
                          <Button loading={this.state.loading} onClick={() => this.unpauseSubscription()}>{t('premium:unpause')}</Button>
                        </div>
                      </Modal.Description>
                    </Modal.Content>
                  </Modal>}
                  <Modal closeIcon open={this.state.pauseSubModal} onClose={() => this.setState({cancelModalOpen: true, pauseSubModal: false})} trigger={<div style={{textAlign:'center', marginTop: 20}}><Button icon style={{width: '22rem'}} secondary onClick={() => this.setState(stripePaused ? {cancelModalOpen: true} : {pauseSubModal: true})}><Icon name='close' /> {t('premium:unsubscribe')}</Button></div>}>
                    <Modal.Content>
                      <Modal.Description>
                          <Header>{t('premium:break')}</Header>
                          <p className="text-center">{t('premium:pauseFor')}
                          </p>
                          <div style={{textAlign: 'center'}}><Select style={{maxWidth: '10rem', marginBottom: '1rem'}} value={this.state.monthsToPause} options={[{ key: 1, value: 1, text: t('premium:oneMonth') },
                            { key: 2, value: 2, text: t('premium:twoMonths') },
                            { key: 3, value: 3, text: t('premium:threeMonths') }]} onChange={(e, data) => this.setState({monthsToPause: data.value})}/></div>
                          <p className="text-center">
                            {t('premium:pauseText')}
                          </p>
                          <div className="text-center">
                            <Button loading={this.state.loading} onClick={() => this.pauseSubscription()}>{t('premium:pauseSub')}</Button>
                            <Button secondary disabled={this.state.loading} onClick={() => this.setState({pauseSubModal: false, cancelModalOpen: true})}>{t('premium:noThanks')}</Button>  
                          </div>
                      </Modal.Description>
                    </Modal.Content>
                  </Modal>
                  <Modal closeIcon open={this.state.cancelModalOpen} onClose={() => this.setState({cancelModalOpen: false})} >
                    <Modal.Content>
                      <Modal.Description>
                          <p id="sad-emoji">😢</p>
                          <Header>{t('premium:unsubModal.title')}</Header>
                          <p className="text-center">{t('premium:unsubModal.part1')}<br />
                          {t('premium:unsubModal.mail')} <a href="mailto:help@gowod.eu">help@gowod.eu</a></p>
                          <Form id="reason-form">
                            <Form.Field>
                              <Checkbox
                                radio
                                label={t('premium:unsubModal.reason1')}
                                name="not-used-enough"
                                value="not-used-enough"
                                checked={this.state.cancelReason === 'not-used-enough'}
                                onChange={() => this.setState({cancelReason: 'not-used-enough'})}
                              />
                            </Form.Field>
                            <Form.Field>
                              <Checkbox
                                radio
                                label={t('premium:unsubModal.reason2')}
                                name="too-expensive"
                                value="too-expensive"
                                checked={this.state.cancelReason === 'too-expensive'}
                                onChange={() => this.setState({cancelReason: 'too-expensive'})}
                              />
                            </Form.Field>
                            <Form.Field>
                              <Checkbox
                                radio
                                label={t('premium:unsubModal.reason3')}
                                name="not-efficient-enough"
                                value="not-efficient-enough"
                                checked={this.state.cancelReason === 'not-efficient-enough'}
                                onChange={() => this.setState({cancelReason: 'not-efficient-enough'})}
                              />
                            </Form.Field>
                            <Form.Field>
                              <Checkbox
                                radio
                                label={t('premium:unsubModal.reason4')}
                                name="other"
                                value="other"
                                checked={this.state.cancelReason === 'other'}
                                onChange={() => this.setState({cancelReason: 'other'})}
                              />
                            </Form.Field>
                            <TextArea value={this.state.reasonAddon} onChange={e => this.setState({reasonAddon: e.target.value})} placeholder={t('premium:unsubModal.addon')} />
                          </Form>
                          
                          <p className="text-center">{t('premium:unsubModal.part2')}</p>
                          <div className="text-center"><Button disabled={this.state.cancelReason === null} loading={this.state.cancelFetching} onClick={() => this.cancelPremium()}>{t('premium:unsubModal.confirm')}</Button></div>
                      </Modal.Description>
                    </Modal.Content>
                  </Modal>
                </div>}
                { !this.state.promocode && !this.props.user.stripeSubscription && this.props.user.premiumDetails && !this.state.notPremium &&
                  <Modal closeIcon trigger={<div style={{textAlign:'center', marginTop: 20}}><Button icon><Icon name='close' /> {t('premium:unsubscribe')}</Button></div>}>
                  <Modal.Content>
                    <Modal.Description>
                      <Header>{t('premium:storesModal.title')}</Header>
                      <p>{t('premium:unsubModal.part1')}<br/>
                      {t('premium:unsubModal.part2')}</p>
                      <p>{t('premium:unsubModal.part3')}</p>
                      <div className="store-link"><Icon size='large' name="apple"/><a href={`https://support.apple.com/${this.props.user.locale}-${this.props.user.locale}/HT202039`} target="_blank" rel="noopener noreferrer">Apple iTunes Store</a></div>
                      <div className="store-link"><Icon size='large' name="android"/><a href="https://support.google.com/googleplay/answer/7018481" target="_blank" rel="noopener noreferrer">Google Play Store</a></div>
                    </Modal.Description>
                  </Modal.Content>
                </Modal>
                }
                <Modal closeIcon open={this.state.paymentModalOpen} onClose={() => this.setState({paymentModalOpen: false})}>
                    <Modal.Content>
                      <Modal.Description>
                          <Header>{t('premium:subscribeModal.title')}</Header>
                          <div className="text-center mt30">
              <p>{this.state.planId === this.state.plans.monthly ? <span>{t('premium:monthly')}: <b>{this.state.pricing.monthly}{t('premium:perMonth')}</b></span> : this.state.planId === this.state.plans.semestrial ? <span>{t('premium:halfYearly')}: <b>{this.state.pricing.semestrial}{t('premium:per6Months')}</b></span> : <span>{t('premium:yearly')}: <b>{this.state.pricing.yearly}{t('premium:perYear')}</b></span>}</p>
                          {!this.props.user.stripeId &&
                            <div id="promocode-container">
                              <Checkbox toggle label={t('premium:subscribeModal.havePromocode')} onChange={this.toggle.bind(this)} checked={this.state.havePromocode}/>
                              {this.state.havePromocode &&
                              <div id="promocode-input-container">
                                <Input
                                  label={<Button content={t('premium:subscribeModal.validate')} disabled={this.state.isPromocodeValid} fetching={this.state.promocodeFetching} onClick={this.validatePromocode.bind(this)} />}
                                  labelPosition='right'
                                  disabled={this.state.isPromocodeValid}
                                  placeholder={t('premium:promocode')}
                                  value={this.state.promocodeValue}
                                  onChange={(e, data) => this.setPromocode(data.value)}
                                />
                                {this.state.isPromocodeValid === true && <Message
                                  success
                                  content={`${t('premium:subscribeModal.validCode1')}`}
                                />}
                                {this.state.isPromocodeValid === false && <Message
                                  error
                                  content={t('premium:subscribeModal.invalidCode')}
                                />}
                              </div>
                              }
                            </div>
                          }
                          <CreditCardInput
                            cardNumberInputProps={{ value: this.state.cardNumber, onChange: (e) => this.setValue({key: 'cardNumber', value: e.nativeEvent.target.value}) }}
                            cardExpiryInputProps={{ value: this.state.expiry, onChange: (e) => this.setValue({key: 'expiry', value: e.nativeEvent.target.value}) }}
                            cardCVCInputProps={{ value: this.state.cvc, onChange: (e) => this.setValue({key: 'cvc', value: e.nativeEvent.target.value}) }}
                            fieldClassName="input"
                            style={{marginTop: '2rem'}}
                          />
                          
                        </div>
                        
                          <p id="first-billing" className="mt10" style={this.state.havePromocode && this.state.isPromocodeValid ? {color: '#7fc75a'} : {}}>
                          {this.state.trialPeriod ? `${this.state.trialPeriod} ${t('premium:subscribeModal:validCode2')}` : ''}<br/>
                            {t('premium:firstBilling')}: {this.getBillingDate()}
                          </p>
                        
                        <div className="text-center mt20"><Button loading={this.state.paymentFetching} disabled={this.state.havePromocode && !this.state.isPromocodeValid} onClick={this.subscribeToPremium.bind(this)}>{t('premium:subscribe')}</Button></div>
                      </Modal.Description>
                    </Modal.Content>
                </Modal>
              </Container>
            }
          </div>
    )
  }
}
 
export default translate('translations')(PremiumPane);


// WEBPACK FOOTER //
// ./src/components/PremiumPane.js